module.exports = __webpack_public_path__ + "img/project_18.59e3cc7f.jpg";